import { render } from "./newSupplyDetail.vue?vue&type=template&id=32abcb58&scoped=true"
import script from "./newSupplyDetail.vue?vue&type=script&lang=js"
export * from "./newSupplyDetail.vue?vue&type=script&lang=js"

import "./newSupplyDetail.vue?vue&type=style&index=0&id=32abcb58&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32abcb58"]])

export default __exports__